import type { StyleableProps } from '~/types';
import type { OAISchema } from '~/types/openapi';

import CouponDiscountedPrice from './CouponDiscountedPrice';
import MembershipStandardNudgeProductPrice from './MembershipStandardNudgeProductPrice';
import RegularProductPrice from './RegularProductPrice';
import { useProductPriceVariant } from './useProductPriceVariant';
import { LuckyDiscountedPrice } from '../LuckyDiscountedPrice';
import MembershipDiscountedPrice from '../MembershipDiscountedPrice';

// TODO: reverse props 제거할 것
export type ProductPriceProps = OAISchema['MarketSelectProductResponseV2'] & {
  reverse?: boolean;
  wFull?: boolean;
  is3x2?: boolean;
} & StyleableProps;

const ProductPrice = (data: ProductPriceProps) => {
  const variant = useProductPriceVariant(data);

  switch (variant) {
    case 'membershipWeek':
      return <MembershipDiscountedPrice {...data} />;
    case 'luckyBonusPack':
      return <LuckyDiscountedPrice {...data} />;
    case 'membershipStandardNudge':
      return <MembershipStandardNudgeProductPrice {...data} />;
    case 'couponDiscounted':
      return <CouponDiscountedPrice {...data} />;
    case 'noDiscount':
      return <RegularProductPrice {...data} />;
    default:
      return null;
  }
};

export default ProductPrice;
